import { DownloadFile, enqueueSnackbar } from 'actions';

import { ProcessAlarmsDiffRequest } from '../requests/AlarmsDiffRequests.js';

// Sends the zip to the API, downloads the Excel and gives the counts back to the component.
export const ProcessAlarmsDiff = (zipFile) => async (dispatch) => {
	try {
		const response = await ProcessAlarmsDiffRequest(zipFile);

		if (response.data && response.data.excelFilePath) {
			dispatch(DownloadFile(response.data.excelFilePath));
		}

		return response.data;
	} catch (error) {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}

		return null;
	}
};
